import { render, staticRenderFns } from "./UnitDetails.vue?vue&type=template&id=023c1cac&scoped=true&"
import script from "./UnitDetails.vue?vue&type=script&lang=js&"
export * from "./UnitDetails.vue?vue&type=script&lang=js&"
import style0 from "./UnitDetails.vue?vue&type=style&index=0&id=023c1cac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023c1cac",
  null
  
)

export default component.exports